<script>
import { colors } from '@/config'

import getShiftedColor from '@/util/getShiftedColor'
import getOptionsString from '@/util/getOptionsString'

export default {

  props: {

    sourceNode: {
      type: Object,
      required: true
    },

    targetNode: {
      type: Object,
      required: true
    }

  },

  data () {
    return {
      color: getShiftedColor(colors.darkBrown)
    }
  },

  computed: {

    points () {
      return [
        [this.sourceNode.renderedX, this.sourceNode.renderedY, this.sourceNode.renderedZ].join(' '),
        [this.targetNode.renderedX, this.targetNode.renderedY, this.targetNode.renderedZ].join(' ')
      ].join(', ')
    },

    // https://github.com/andreasplesch/aframe-meshline-component
    meshlineOptions () {
      return getOptionsString({
        lineWidth: 10,
        path: this.points,
        color: this.color
        // lineWidthStyler: 'Math.abs(p - 0.5)'
      })
    }

  }

}
</script>

<template>
  <a-entity
    geometry="width: 1; height: 1; depth: 2;"
    material="visible: false"
  >
    <a-entity
      :meshline="meshlineOptions"
      position="0 0 -0.95"
    />
  </a-entity>
</template>
